import { createSelector } from '@ngrx/store';
import { getGlobalHomeFeatureStore } from '../index';

const getUserConnectionFeatureState = createSelector(
  getGlobalHomeFeatureStore,
  state => state.userConnections
);

export const userConnectionUsers = createSelector(
  getUserConnectionFeatureState,
  state => state.connections
);

export const userConnectionPageInfo = createSelector(
  getUserConnectionFeatureState,
  state => state.pageInfo
);
export const userConnectionError = createSelector(
  getUserConnectionFeatureState,
  state => state.error
);
export const userConnectionLoading = createSelector(
  getUserConnectionFeatureState,
  state => state.loading
);
